var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$_tag,_vm._g(_vm._b({tag:"component",staticClass:"BaseFormButton base-form-button",attrs:{"tabindex":"0","loading":_vm.isSpinner,"disabled":_vm.isDisabled,"large":""}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }